import React from 'react';
import jobs from './jobs.json';
import './jobs.css';

const Jobs = () => {
  return (<div id='jobs' className='row m-0'>
    <div className='container-fluid px-0'>
      <div className='jumbotron text-center bg-joinImg hero-height'>
        <h1 className='text-center mt-5 pt-5'>
          join(<span className='text-red'>Us</span>)
        </h1>
      </div>
      <div className='container'>
        <div className='row mx-0'>
          <h5 className='col-3'>
            Title
          </h5>
          <h5 className='col-9'>
            Location
          </h5>

        </div>

        {
          jobs.map((jobs, index) => {
            return (<div key={jobs.id} className='row mx-0 border-top py-2'>
              <div className='col-3 p-2'>
                {jobs.title}
              </div>

              <div className='col-3 p-2'>
                {jobs.location}
              </div>

              <div className='col-3'>
                <button className='btn btn-dark' type='button' data-toggle='collapse' data-target={'#job' + jobs.id} aria-expanded='false' aria-controls='collapse'>
                  Description
                </button>
              </div>
              <div className='col-3'>
                <button type="button" class="btn btn-dark" data-toggle="modal" data-target={'#jobsModal' + jobs.id}>
                  Apply
                </button>
                <div class="modal fade" id={'jobsModal' + jobs.id} tabIndex="-1" role="dialog" aria-labelledby="modalTitle" aria-hidden="true">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title" id="modalTitle">Introduce yourself.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-header">
                        <form class=" form-group">
                          <h3>Job Application</h3>
                          <div>Job Title:</div><input className='pl-3' value={jobs.title}/>
                          <div>Location:</div><input className='pl-3' value={jobs.location}/>
                          <div>First Name:</div><input className='pl-3' placeholder='First Name'/>
                          <div>Last Name:</div><input className='pl-3' placeholder='Last Name'/>
                          <div>Email Address:</div><input className='pl-3' placeholder='you@email.com'/>
                          <div>Name :</div><input className='pl-3' placeholder='First Name'/>
                          <div>LinkedIn:</div><input className='pl-3' placeholder='https://www.linkedin.com/in/your-name/'/>
                          <div>Website:</div><input className='pl-3' placeholder='www.example.com'/>
                          <div>Cover Letter:</div><textarea placeholder='Cover Letter'/>
                          <input className='p-0 border-0' type="file" name="ApplicantResume"/>
                        </form>
                      </div>

                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-dark">Submit</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='collapse p-2 mt-2 w-100' id={'job' + jobs.id}>
                <small>
                  <p>
                    {jobs.description}
                  </p>
                  <p>
                    <ul>
                      {
                        jobs.requirements.map(requirements => {
                          return (<li key={jobs.requirements}>
                            {requirements}
                          </li>)
                        })
                      }
                    </ul>
                  </p>
                </small>
              </div>
            </div>)
          })
        }
      </div>
    </div>
  </div>)
}

export default Jobs;



// WEBPACK FOOTER //
// ./src/components/Jobs/Jobs.js